import { render, staticRenderFns } from "./DashboardVisitasNuser.vue?vue&type=template&id=852532ea&scoped=true"
import script from "./DashboardVisitasNuser.vue?vue&type=script&lang=js"
export * from "./DashboardVisitasNuser.vue?vue&type=script&lang=js"
import style0 from "./DashboardVisitasNuser.vue?vue&type=style&index=0&id=852532ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852532ea",
  null
  
)

export default component.exports